import { SubPayAppsList } from "@/components/pay-apps/SubPayAppsList";

export function SubcontractPayAppsPage() {
  return <SubPayAppsList />;
}
